import React from 'react';

import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

import localeStore from 'src/stores/LocaleStore';

interface Props {
  children: React.ReactNode;
}

export const RecaptchaProvider = (props: Props) => {
  const recaptchaKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

  if (!recaptchaKey) {
    return props.children;
  }

  const locale = localeStore.currentLocaleCountryCode;

  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={recaptchaKey}
      language={locale.toLowerCase() || 'en'}
      /**
       * useRecaptchaNet uses an alternative domain which has a higher
       * probability it isn't blocked by DSPs in foreign countries.
       */
      useRecaptchaNet={true}
      scriptProps={{
        async: true,
        defer: true,
        appendTo: 'body'
      }}>
      {props.children}
    </GoogleReCaptchaProvider>
  );
};
